import * as _ from "lodash";

import { TextControl } from "../../controls/textControl";
import { UiUtils } from "../../common/uiUtils";
import { viewerOptions } from "../../viewer";
import { BuildOrderPanel } from "./buildOrderPanel";

export class BuildOrderToolbar {

    private subToolbar: Autodesk.Viewing.UI.ControlGroup;
    private toolbarDiv: HTMLDivElement;
    private positionText: TextControl;

    private openButton: Autodesk.Viewing.UI.Button;
    private rewindButton: Autodesk.Viewing.UI.Button;
    private backButton: Autodesk.Viewing.UI.Button;
    private forwardButton: Autodesk.Viewing.UI.Button;
    private fastForwardButton: Autodesk.Viewing.UI.Button;
    private autoButton: Autodesk.Viewing.UI.Button;
    private pauseButton: Autodesk.Viewing.UI.Button;
    private buttonGroup: Autodesk.Viewing.UI.ControlGroup;

    private traverseBuildOrder: (step: number) => void;
    private autoPlay: (enabled: boolean) => void;

    private buildOrderPanel: BuildOrderPanel;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D, subToolbar: Autodesk.Viewing.UI.ControlGroup, traverse: (step: number) => void, autoPlay: (enabled: boolean) => void, setBuildOrder) {
        this.subToolbar = subToolbar;
        this.traverseBuildOrder = traverse;
        this.autoPlay = autoPlay;

        this.buildOrderPanel = new BuildOrderPanel(viewer, viewer.container, setBuildOrder);
        this.createBuildOrderToolbar();
    }

    private createBuildOrderToolbar() {
        if (!_.isEmpty(viewerOptions.buildOrders)) {
            this.openButton = UiUtils.createButton({
                id: "SmartDrawings.BuildOrderButtonOpen",
                tooltip: "Open build order",
                iconClass: "ion-md-folder-open",
                onClick: () => {
                    this.buildOrderPanel.setVisible(!this.buildOrderPanel.isVisible());
                }
            });
        }

        this.rewindButton = UiUtils.createButton({
            id: "SmartDrawings.BuildOrderButtonRewind",
            tooltip: "Build order",
            iconClass: "ion-md-rewind",
            onClick: () => {
                this.traverseBuildOrder(-25);
            }
        });

        this.backButton = UiUtils.createButton({
            id: "SmartDrawings.BuildOrderButtonBack",
            tooltip: "Build order",
            iconClass: "ion-md-arrow-dropleft",
            onClick: () => {
                this.traverseBuildOrder(-1);
            }
        });

        this.forwardButton = UiUtils.createButton({
            id: "SmartDrawings.BuildOrderButtonForward",
            tooltip: "Build order",
            iconClass: "ion-md-arrow-dropright",
            onClick: () => {
                this.traverseBuildOrder(1);
            }
        });

        this.fastForwardButton = UiUtils.createButton({
            id: "SmartDrawings.BuildOrderButtonFastForward",
            tooltip: "Build order",
            iconClass: "ion-md-fastforward",
            onClick: () => {
                this.traverseBuildOrder(25);
            }
        });

        this.autoButton = UiUtils.createButton({
            id: "SmartDrawings.BuildOrderButtonAuto",
            tooltip: "Build order",
            iconClass: "ion-md-play-circle",
            onClick: () => {
                this.startAuto();
            }
        });

        this.pauseButton = UiUtils.createButton({
            id: "SmartDrawings.BuildOrderButtonAuto",
            tooltip: "Build order",
            iconClass: "ion-md-pause",
            onClick: () => {
                this.pauseAuto();
            }
        });

        this.positionText = new TextControl("SmartDrawings.BuildOrderPosition");

        const toolbar = new Autodesk.Viewing.UI.ToolBar("SmartDrawings.BuildOrderToolbar");
        // Set these here or Viewer's CSS will over-ride them.
        toolbar.container.style.bottom = "0px";
        toolbar.container.style.width = "100%";
        this.buttonGroup = new Autodesk.Viewing.UI.ControlGroup("SmartDrawings.BuildOrderGroup");
        this.buttonGroup.container.classList.add("smartdrawings-toolbar-group");
        // Viewer 7.* css screws up the display attribute, so override here.
        this.buttonGroup.container.style.display = "flex";
        if (this.openButton != null) {
            this.buttonGroup.addControl(this.openButton);

            this.buildOrderPanel.addVisibilityListener(visible => {
                this.openButton.setState(visible ? Autodesk.Viewing.UI.Button.State.ACTIVE : Autodesk.Viewing.UI.Button.State.INACTIVE);
            });

        }
        this.buttonGroup.addControl(this.rewindButton);
        this.buttonGroup.addControl(this.backButton);
        this.buttonGroup.addControl(this.positionText);
        this.buttonGroup.addControl(this.forwardButton);
        this.buttonGroup.addControl(this.fastForwardButton);
        this.buttonGroup.addControl(this.autoButton);
        toolbar.addControl(this.buttonGroup);

        this.toolbarDiv = document.createElement("div");
        this.toolbarDiv.classList.add("docking-panel");
        this.toolbarDiv.classList.add("docking-panel-container-solid-color-b");
        this.toolbarDiv.classList.add("smartdrawings-toolbar-div");
        this.hide();

        this.subToolbar.container.appendChild(this.toolbarDiv);
        this.toolbarDiv.appendChild(toolbar.container);
    }

    private startAuto() {
        this.buttonGroup.removeControl(this.autoButton);
        this.buttonGroup.addControl(this.pauseButton);
        this.autoPlay(true);
    }

    private pauseAuto() {
        this.setPaused();
        this.autoPlay(false);
    }

    private setPaused() {
        this.buttonGroup.removeControl(this.pauseButton);
        this.buttonGroup.addControl(this.autoButton);
    }

    updateUi(position: number, modelSize: number, canGoBack: boolean, canGoForward: boolean, autoPlay: boolean) {
        this.positionText.setText(`${position + 1} / ${modelSize}`);
        UiUtils.setButtonEnabled(this.rewindButton, canGoBack);
        UiUtils.setButtonEnabled(this.backButton, canGoBack);
        UiUtils.setButtonEnabled(this.forwardButton, canGoForward);
        UiUtils.setButtonEnabled(this.fastForwardButton, canGoForward);
        if (!canGoForward || !autoPlay) {
            this.setPaused();
        }
    }

    buildOrderActive() {
        return !this.toolbarDiv.classList.contains("d-none");
    }

    show() {
        this.toolbarDiv.classList.remove("d-none");
    }

    hide() {
        this.toolbarDiv.classList.add("d-none");
        this.buildOrderPanel.setVisible(false);
    }
}